import {alertDialog, confirmDialog} from '@/lib/common';
import {isLoggedIn, login} from '@/lib/user-auth0.js';
// shared messages
export default {
  data () {
    return {
      commonMsg: null
    }
  },
  created () {
    this.commonMsg = this.confirmMsgGenerator(this.recordName || '');
  },
  methods: {
    confirmMsgGenerator (name) {
      return {
        deny: {
          view: `Can't view ${name}, please make sure you have permission.`,
          delete: `Can't delete ${name}, please make sure you have permission.`,
          add: `Can't add ${name}, please make sure you have permission.`,
          update: `Can't update ${name}, please make sure you have permission.`
        },
        done: {
          add: `${name} successfully added.`,
          delete: `${name} successfully deleted.`,
          update: `${name} successfully updated.`,
          batchDelete: `Selected ${name} record(s)successfully deleted.`
        },
        fail: {
          view: `Failed to get ${name} records.`,
          add: `Failed to add one ${name} record.`,
          delete: `Failed to delete ${name}.`,
          update: `Failed to update ${name}.`,
          batchDelete: `Failed to delete selected ${name} record(s).`
        },
        confirm: {
          delete: `You have chosen to delete one ${name}. Are you sure? Click "Yes" to continue, or choose "Cancel”.`,
          batchDelete: `You chosen to delete one ${name}. Are you sure? Click "Yes" to continue, or choose "Cancel”.`
        },
        selectionRequired: `Please choose ${name} first.`
      }
    },
    commonInsertUpdate (url, postObj, actionKey, successAction, failedAction, noteMsg = '') {
      this.errors = [];
      this.$http.post(url, postObj).then(function (response) {
        if (response.data.hasOwnProperty.call('error')) {
          this.errors.push(this.commonMsg.fail[actionKey] + noteMsg + response.data.error);
        } else {
          this.errors = [];
          this.errors.push(this.commonMsg.done[actionKey]);
          successAction && successAction(response);
        }
      }, (response) => {
        this.errors.push(this.commonMsg.fail[actionKey] + noteMsg + response.data.error);
        failedAction && failedAction(response);
      }
      );
    },

    commonBatchDelete (url, postObj, count, successAction, noteMsg = '', actionKey = 'batchDelete') {
      confirmDialog(this.$modal, 'Delete', `You choose to delete ${count} ${this.recordName}(s), click "Yes" to continue, click "Cancel" to Cancel. `,
        'Yes', () => { this._commonDelete(url, postObj, successAction, noteMsg, actionKey); },
        'Cancel'
      );
    },
    commonDelete (url, postObj, successAction, noteMsg = '', actionKey = 'delete') {
      confirmDialog(this.$modal, 'Delete', this.commonMsg.confirm.delete,
        'Yes', () => { this._commonDelete(url, postObj, successAction, noteMsg, actionKey); },
        'Cancel'
      );
    },
    _commonDelete (url, postObj, successAction, noteMsg = '', actionKey) {
      this.$http.post(url, postObj).then(
        response => {
          if (response.data.hasOwnProperty.call('error')) {
            alertDialog(this.$modal, 'Error', `<span class="error">${this.commonMsg.fail[actionKey]} ${noteMsg} </span> <br>${response.data.error}`);
          } else {
            alertDialog(this.$modal, 'Done', this.commonMsg.done[actionKey]);
            successAction(response);
          }
        }, (response) => {
          console.error(response);
          alertDialog(this.$modal, 'Error', `<span class="error">${this.commonMsg.fail[actionKey]} ${noteMsg} </span> <br> ${response.data}`); 
        });
    },
    async commonGet (url, params, showAlert, successAction, failedAction) {
      this.errors = [];
      try {
        const response = await this.$http.get(url, params);
        if (response.data.hasOwnProperty.call('error')) {
          if (showAlert) {
            console.error(response.data.error)
            this.errors.push(this.commonMsg.fail['view']);
          }
          if (failedAction) {
            failedAction(response);
          }
        } else {
          if (showAlert) {
            this.errors = [];
            this.errors.push(this.commonMsg.done['view']);
          }
          successAction(response);
        }
      } catch (e) {
        console.log('failed ,..', e);
        if (e.status === 401 || e.status === 401) {
          if (!isLoggedIn()) {
            login();
          }
        }
        if (showAlert) {
          console.error(e);
          this.errors.push(this.commonMsg.fail['view'] + e);
        }
      }
    },

    async commonPost (url, params, showAlert, successAction, failedAction, actionKey = 'update') {
      this.errors = [];
      try {
        const response = await this.$http.post(url, params);
        if (response.data.hasOwnProperty.call('error')) {
          if (showAlert) {
            console.error(response.data.error);
            this.errors.push(this.commonMsg.fail[actionKey] + response.data.error);
            if (failedAction) {
              failedAction(response);
            }
          }
        } else {
          if (showAlert) {
            this.errors = [];
            this.errors.push(this.commonMsg.done[actionKey]);
          }
          successAction(response);
        }
      } catch (e) {
        console.log('failed ,..', e);
        if (e.status === 401 || e.status === 401) {
          if (!isLoggedIn()) {
            login();
          }
        }
        if (showAlert) {
          console.error(e);
          this.errors.push(this.commonMsg.fail[actionKey] + e);
          if (failedAction) {
            failedAction(e);
          }
        }
      }
    },
    async postAndPassBack (url, params, successAction, failedAction) {
      try {
        const response = await this.$http.post(url, params);
        if (response.data.hasOwnProperty.call('error')) {
          if (failedAction) {
            failedAction(response.data);
          }
        } else {
          successAction(response);
        }
      } catch (e) {
        console.log('failed ,..', e);
        if (e.status === 401 || e.status === 401) {
          if (!isLoggedIn()) {
            login();
          }
        }
        failedAction(e);
      }
    },
    async getAndPassBack (url, params, successAction, failedAction) {
      try {
        const response = await this.$http.get(url, params);
        if (response.data.hasOwnProperty.call('error')) {
          if (failedAction) {
            failedAction(response.data);
          }
        } else {
          successAction(response);
        }
      } catch (e) {
        console.log('failed ,..', e);
        if (e.status === 401 || e.status === 401) {
          if (!isLoggedIn()) {
            login();
          }
        }
        failedAction(e);
      }
    }
  }
}
